import React from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { toAbsoluteUrl } from '../../assets/helpers/AssetHelpers';
import useReRouteHook from '../../assets/hooks/useReRouteHook';
import { BreadcrumbLoader } from '../common/JainamLoader/JainamLoader';

interface SubChildHeaderProps {
	childCategoryName: string;
	childName: string;
	MainCategoryTitle: string;
}

const SubChildHeader: React.FC<SubChildHeaderProps> = ({
	childCategoryName,
	childName,
	MainCategoryTitle,
}) => {
	const { category_name, child_category_name, child } = useParams();
	const navigate = useNavigate();

	const { reRouteButtonRenderer } = useReRouteHook();
	if (!category_name || !child_category_name || !child) {
		navigate('/no-results-found');
		return null;
	}
	return (
		<div className="d-flex px-0">
			<div className="col-lg-12 col-12">
				<nav aria-label="breadcrumb" className="px-0 px-md-3 px-lg-0">
					<ol className="breadcrumb cursor-pointer in_reg fs-sm-14 mt-4 mt-lg-0">
						<li className="breadcrumb-item active" aria-current="page">
							{reRouteButtonRenderer({
								url: '/',
								classes: 'color1 in_reg border-0 bg-transparent',
								nameText: 'Home',
							})}
						</li>
						<li className="breadcrumb-item">
							{MainCategoryTitle ? reRouteButtonRenderer({
								url: `/category/${category_name}/`,
								classes: 'color1 in_reg border-0 bg-transparent',
								nameText: MainCategoryTitle,
							}) : <BreadcrumbLoader />}
						</li>
						<li className="breadcrumb-item">
							{childCategoryName ? reRouteButtonRenderer({
								url: `/category/${category_name}/${child_category_name}`,
								classes: 'color1 in_reg border-0 bg-transparent',
								nameText: childCategoryName,
							}) : <BreadcrumbLoader />}
						</li>
						<li className="breadcrumb-item">
							{childName ? reRouteButtonRenderer({
								url: `/category/${category_name}/${child_category_name}/${child}`,
								classes: 'color1 in_reg border-0 bg-transparent',
								nameText: childName,
							}) : <BreadcrumbLoader />}
						</li>
					</ol>
				</nav>
			</div>
		</div>
	);
};

export default SubChildHeader;
